import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { MatSelectChange } from '@angular/material/select';

import { PraxisService } from '../../service/praxis.service';

import { TipoDocumentos } from '../../interface/TipoDocumentoInterface';
import { TipoIva } from '../../interface/TipoIva';
import { TipoIibb } from '../../interface/TipoIIBBInterface';
import { FormaPago } from '../../interface/FormaPago';
import { Tarjetas } from '../../interface/Tarjetas';
import { Sexo } from '../../interface/sexo';
import { MatDialog } from '@angular/material/dialog';
import { CuitCuil } from '../../interface/cuit';
import { PersonasService } from '../../../../../__ConsultaPersonasComponent__/service/personas.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Documento } from '../../interface/Documento';
import { documentoLengthValidator } from '../../../../../validators/custom-validators';


@Component({
    selector: 'app-contratar',
    templateUrl: './contratar.component.html',
    styleUrl: './contratar.component.css',
    standalone: false
})
export class ContratarComponent implements OnInit {



  public documentos: TipoDocumentos[] = [];
  public iva: TipoIva[] = [];
  public iibb: TipoIibb[] = [];
  public formapago: FormaPago[] = [];
  public tarjetas: Tarjetas[] = [];
  public documento: Documento[] = [];

  formapago_option: number = 0;
  tipodocumento_option: number = 0;
  public cuit: CuitCuil ={
    cuil_cuit: ''
  };

  contratarFormGroup: FormGroup;
  token_persona: string = '';
  public tipo_documento: string = '';



  constructor(
    private _formBuilder: FormBuilder,
    private praxisService: PraxisService,
    private personas: PersonasService,
    private router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog
  ){
    this.contratarFormGroup = this._formBuilder.group({
      numerodocControl: ['', [Validators.required, Validators.minLength(11), Validators.maxLength(11)]],
      calleControl: ['', Validators.required],
      altura_numeroControl: ['', Validators.required],
      formapagoControl: [''],
      tarjetaControl: [0, Validators.required],
      numeroControl: ['', Validators.required]

    });
  }

  ngOnInit(): void {
    const token = localStorage.getItem('token');
    if (token != null){
      /*
      this.praxisService.getTipoDocumento(token)
                        .subscribe(
                          (datos) => {
                            this.documentos = datos;
                          }
                        )
                        */
      this.praxisService.getFormaPago(token)
                        .subscribe(
                          (datos) => {
                            this.formapago = datos;
                          }
                        )
        this.praxisService.getTarjetas(token)
                          .subscribe(
                            (datos) => {
                              this.tarjetas = datos;
                            }
                          )
          const tipo_iva = localStorage.getItem('iva');
          if (tipo_iva != null){
          this.praxisService.getCorrespondeDocumento(token, tipo_iva)
                            .subscribe(
                              (datos) => {
                                this.documento = datos;
                                if (this.documento[0].tipo_documento == '2'){
                                  this.tipo_documento = 'CUIT'
                                } else if (this.documento[0].tipo_documento == '10'){
                                  this.tipo_documento = 'CUIL'
                                }
                              }
                            )
                          }
    }

  }
  /*
  obtenerCategoriaIva($event: MatSelectChange): void
  {
    this.tipo_documento_select($event);
    const token = localStorage.getItem('token');
    if (token != null){
      this.praxisService.getIva(token, $event.value)
                        .subscribe(
                          (datos) => {
                            this.iva = datos;
                          }
                        )

        if ($event.value == 2){
          this.praxisService.getIngresosBrutos(token)
                            .subscribe(
                              (datos) => {
                                this.iibb = datos;
                              }
                            )
          this.contratarFormGroup.get('iibbControl')?.enable();
        } else {
          this.contratarFormGroup.get('iibbControl')?.disable();
          this.contratarFormGroup.controls['iibbControl'].setValue(0);
        }
    }


  }
  */


  forma_pago_select($event: MatSelectChange): void{
    this.formapago_option = $event.value
  }

  tipo_documento_select($event: MatSelectChange): void{
    this.tipodocumento_option = $event.value
  }


    contratar(){
      /*
      if (this.tipo_documento == 'CUIT'){
        const asegurado = localStorage.getItem('apellido');

        const parts = asegurado?.trim().split(' ');

        if (parts != undefined){
          localStorage.setItem('apellido', parts[1]);
          localStorage.setItem('nombre', parts[0]);
        }
      }
        */
      localStorage.setItem('solicitar', 'true');

      localStorage.setItem('nrodoc', this.contratarFormGroup.controls['numerodocControl'].value);
      localStorage.setItem('calle', this.contratarFormGroup.controls['calleControl'].value);
      localStorage.setItem('altura', this.contratarFormGroup.controls['altura_numeroControl'].value);
      if (this.contratarFormGroup.controls['formapagoControl'].value == 'CBU'){
        localStorage.setItem('conducto_pago', '19');
      }else{
        localStorage.setItem('conducto_pago', this.contratarFormGroup.controls['tarjetaControl'].value);
      }
      localStorage.setItem('numero_tarjeta', this.contratarFormGroup.controls['numeroControl'].value);

      this.router.navigate(['../solicitar'], {relativeTo: this.route});



    }

    onCardDetected(cardData: { cardNumber: string, cardType: string, cardLogo: string, codCard: string | null, requiredLength: number }): void {
      // Actualiza el control numeropagoControl con el número de tarjeta detectado
      this.contratarFormGroup.patchValue({
        numeroControl: cardData.cardNumber,
        tarjetaControl: cardData.codCard,
      });

      // Si deseas, puedes guardar cardType y cardLogo en variables locales o en otros controles


      if (this.contratarFormGroup.get('formapagoControl')?.value === 'tarjeta') {
        const control = this.contratarFormGroup.get('numeroControl');
        control?.setValidators([
          Validators.required,
          Validators.minLength(cardData.requiredLength),
          Validators.maxLength(cardData.requiredLength)
        ]);
        control?.updateValueAndValidity();
      }
    }





}
